import {useEffect, useRef, useState,} from 'react'
import axios from 'axios'
import {Url} from "../services/Constants"
import {Setauth} from "../services/Auth"
import toast from 'react-hot-toast'
import { HighlightOff,ShoppingCart,BusinessCenter,ArrowBack } from '@mui/icons-material'

export default function Registeration({data}) {

    const mobileNumber = useRef()
    const name = useRef()
    const email = useRef()
    const company = useRef()
    const acceptance = useRef()
    const profile_pic = useRef()
    const finalotp = useRef()
    const gstNumber = useRef()

    const [numberErr,setNumberErr] = useState(false)
    const [usertype,setUserType] = useState(false) // true:a seller, false:a buyer  By default a buyer
    const [nameErr,setNameErr] = useState(false)
    const [terms,setTerms] = useState(false)
    const [policy,setPolicy] = useState(false)
    const [otp,setOtp] = useState(false)
    const [mobile, setMobile] = useState()
    const [gst, setGst] = useState()
    const [seconds, setSeconds ] =  useState(59);
    const [resend,setResend] = useState(false)
    const [formdata,setFormdata] = useState()
    // const [termsContent, setTermsContent] = useState('');
    

    useEffect(()=>{
    },[data.register])



    const registerToggle=()=>{
        data.registerHandle()
    }

    const loginToggle =()=>{
        data.loginHandle()
        data.registerHandle()
    }

    const userTypeToggle = ()=> {
        setUserType(!usertype)
    }

    const numberCheck = ()=>{
        const value = mobileNumber.current.value
        const isNumber = (value) => {
            return isNaN(value) && value.trim() !==' ';
          }
        if(isNumber(value)){
                setNumberErr(true)
        }else
        {
            setNumberErr(false)
        }
    }

    const numberLengthCheck = ()=>{
      const value = mobileNumber.current.value
      const valueLength = value.length
      const numberLength = value.trim().length
      if(numberLength<10 && numberLength>0 || valueLength===1){
        setNumberErr(true)
      }else
      {
          setNumberErr(false)
      }
    }

    const isText = (value) => {
        const input = value
        const namePattern = /^[A-Za-zÀ-ÿ\s'-]+$/
        return namePattern.test(input)
      }

    const nameCheck=()=>{
        const value = name.current.value
        if(!isText(value)){
            setNameErr(true)
        }
        else{
            setNameErr(false)
        }
    }

    const resendTimer=()=>{
      const timeout = ()=>{}
      setTimeout(timeout,1000) 
    }



   const getOtp = async (e)=>{
        e.preventDefault()
        let form = e.target
        let formData = new FormData(form)
        let formObj = Object.fromEntries(formData)
        setMobile(formObj.mobile_number)
        if(!usertype){
          formObj={...formObj,mobile_code:91,role:"buyer"}
          setFormdata(formObj)
        try {
          const result = await axios.post(`${Url}/buyer/registrations`, formObj)
          const response = result.data.response_code
          if(response !== 400){
            toast.success("OTP send Successfully")
            setOtp(!otp)
            resendTimer()
          }
          else{
            toast.error("Mobile number is already registered!")
          }
        } catch (error) {
          console.log(error)
        }
      }else if(usertype){
        formObj={...formObj,mobile_code:91,role:"seller"}    //*** gst validation pensing
        setFormdata(formObj)
        try {
          let gstNumber = formObj.gst_number
          // const gstValidate = await axios.post(`${Url}/gst/validate`, gstNumber)            
        try {
          const result = await axios.post(`${Url}/seller/registrations`, formObj)
          const response = result.data.response_code
          if(response !== 400){
            toast.success("OTP send Successfully")
            setOtp(!otp)
          }
          else{
            toast.error("Mobile number is already registered!")
          }
        } catch (error) {
          console.log(error)
        }

        } catch (error) {
          console.log(error)
        } 

      }
        
    }


    const submitOtp = async (e)=>{
      e.preventDefault()
        let otpData = {
          mobile_number:formdata.mobile_number,
          mobile_code:formdata.mobile_code,
          role:formdata.role,
          otp:finalotp.current.value
        }
        try {
          const result = await axios.post(`${Url}/sessions/verify_otp`, otpData)
          if(result.data.response_code !== 400){
            toast.success("Logged In Successfully")
            const token = result.data.response_data.token
            Setauth(token)
            data.loggedinHandle()
            registerToggle()

          }else{
            toast.error("Invalid OTP!")
          }
        } catch (error) {
          console.log(error)
        }
    }
  


  return (
    <>
    {data.register?<div className="register-container w-full min-h-screen bg-opacity-75 bg-black flex justify-center items-center fixed top-0 z-50">
    <div className=" register-modal w-[30%] bg-gray-300 rounded-2xl absolute shadow-2xl z-40 max-sm:w-[90%]">
      <div className="register-modal-top w-full flex flex-col justify-center items-center">
        <div className={otp?"close w-full text-end p-[1.2%] flex justify-between":" close w-full text-end p-[1.2%]"}>
          {otp?<ArrowBack
          sx={{ fontSize: 28 }}
          className="cursor-pointer rounded-full ml-1 mt-1" 
          onClick={()=>setOtp(!otp)}/>:""}
          <HighlightOff sx={{ fontSize: 28 }} className="hover:bg-red-700 hover:text-white cursor-pointer rounded-full mr-1 mt-1 p-0" onClick={registerToggle} /></div>
        <img
          src="assets/Logo.png"
          alt="Tsofie-logo"
          className="w-2/5 mb-[2%]"
        />
        <div className="register-type mt-[2%] mb-[4%] text-white rounded-t-lg bg-amber-950 flex w-3/4 justify-center items-center">
            {!usertype?<><div className="register-buyer py-2 text-center rounded-t-lg text-black font-bold bg-gradient-to-b from-amber-950 via-amber-800 to-gray-300 w-1/2 cursor-default ">
                <ShoppingCart/>
                <span className="buyer-form">Buy</span>
            </div>
            <div className="register-seller py-2 text-center w-1/2 cursor-pointer hover:text-gray-400" onClick={!otp?userTypeToggle:(e)=>e.preventDefault()}>
                <BusinessCenter/>
                <span className="seller-form">Sell</span>
            </div></>
            :<><div className="register-buyer py-2 text-center w-1/2 cursor-pointer hover:text-gray-400" onClick={!otp?userTypeToggle:(e)=>e.preventDefault()}>
                <ShoppingCart/>
                <span className="buyer-form">Buy</span>
            </div>
            <div className="register-seller py-2 text-center rounded-t-lg text-black font-bold bg-gradient-to-b from-amber-950 via-amber-800 to-gray-300 w-1/2 cursor-default">
                <BusinessCenter/>
                <span className="seller-form">Sell</span>
            </div></>}
        </div>
      </div>
      <form onSubmit={getOtp} className=" form-control register-modal-bottom flex flex-col justify-center items-center" encType="multipart/form-data">
        {!otp?<>
          <input type="file" name="profile_pic" id="" className='invisible h-0 w-0 m-0 p-0' ref={profile_pic} />
        {nameErr?<span className="numbererr text-red-700 w-3/4 pl-3 text-left text-xs">Please Enter A Valide Name!</span>:""}
        <input
          type="text"
          name='name'
          ref={name}
          className={!nameErr?"form-control w-3/4 box-border mb-[3%] p-3 outline-none shadow-xl rounded-3xl":"form-control w-3/4 box-border mb-[3%] p-3 outline-none border-2 border-red-700 shadow-xl rounded-3xl"}
          placeholder="Your Full Name"
          onChange={nameCheck}
          required
        />
        {numberErr?<span className="numbererr text-red-700 w-3/4 pl-3 text-left text-xs">Please Enter A Valide Mobile Number!</span>:""}
        <input
          type="text"
          name="mobile_number"
          className={!numberErr?"form-control w-3/4 box-border mb-[3%] p-3 outline-none shadow-xl rounded-3xl":"form-control w-3/4 box-border mb-[3%] p-3 outline-none border-2 border-red-700 shadow-xl rounded-3xl"}
          placeholder="Your Mobile Number"
          ref={mobileNumber}
          maxLength={10}
          onKeyUp={numberCheck}
          onBlur={numberLengthCheck}
          required
        />
        <input
          type="email"
          name="email"
          className="form-control w-3/4 box-border mb-[3%] p-3 outline-none shadow-xl rounded-3xl"
          ref={email}
          placeholder="Your Email Address"
          required
        /></>:""}
        {usertype && !otp?<><input
          type="text"
          name='company_name'
          className="form-control w-3/4 h-10 box-border mb-[3%] p-3 outline-none shadow-xl rounded-3xl"
          ref={company}
          placeholder="Company Name"
          required
        /></>:""}
        <input
          type="text"
          name='gst_number'
          className="form-control w-3/4 h-10 box-border mb-[3%] p-3 outline-none shadow-xl rounded-3xl"
          placeholder="GST Number"
          ref={gstNumber}
          onInput={(e) => e.target.value = ("" + e.target.value).toUpperCase()}
          maxLength={15}
          required={usertype}
        />
        {!otp?<div className="register-policy mb-[3%] w-3/4 text-sm box-border items-start flex ">
        <input
          type="checkbox"
          className="from-control m-1 outline-none accent-amber-950"
          ref={acceptance}
          required
          />
          <span className="register-policy-text text-gray-600">I agree the{" "}
          <span className="text-amber-950 font-bold cursor-pointer underline" onClick={()=>setTerms(!terms)}>Terms of Services{" "}</span>and{" "}
          <span className="text-amber-950 font-bold cursor-pointer underline" onClick={()=>setPolicy(!policy)}>Privacy Policy</span></span>
        </div>:""}
        {otp?<>
        <span className="freezenumber w-3/4 h-10 border bg-white opacity-50 text-amber-950 mb-3 p-2 font-bold shadow-xl rounded-3xl">{mobile}</span>
        <input
          type="password"
          className=" w-3/4 h-10 box-border mb-1 p-3 outline-none shadow-xl rounded-3xl"
          placeholder="Enter OTP"
          ref={finalotp}
          maxLength={6}
        />
        <div className="resend-otp mb-5 w-[70%] "><span className="text-gray-600">Didn't Receive OTP?{" "}</span>
        <span className={!resend?"text-amber-950 cursor-pointer font-bold hover:underline":"text-amber-950 opacity-50 cursor-default"}>Resend</span>{resend?<span className="timer">{seconds}</span>:""}
        </div></>:""}
        {!otp?<button type="submit" className="get-otp w-3/4 h-10 box-border mb-[3%] text-center cursor-pointer font-bold pt-1.5 text-white text-xl shadow-xl rounded-xl bg-gradient-to-l from-amber-950 via-amber-900 to-amber-800" >
          Get OTP
        </button>:""}
        {otp?<button className="register-submit w-3/4 h-10 box-border mb-[3%] text-center cursor-pointer font-bold pt-1.5 text-white text-xl shadow-lg rounded-xl bg-gradient-to-l from-amber-950 via-amber-900 to-amber-800 hover:shadow-none" onClick={submitOtp}>
          Submit
        </button>:""}
        {!otp?<div className="register-text mb-[4%] cursor-default">
          <span className="text-gray-600">Already have an account?{" "}</span>
          <span className="text-amber-950 font-bold cursor-pointer hover:underline" onClick={loginToggle}>
            Sign-In
          </span>
        </div>:""}
      </form>
    </div>
    {terms?<div className="terms w-[70%]  bg-gray-100 rounded-md z-40 max-sm:w-[90%]">
        <div className="term-title text-center font-bold p-2 text-2xl shadow-md">
        <span className="title text-amber-950">Terms of Services</span>
        </div>
        <div className="term-containt p-1 h-full overflow-y-scroll border-b-2">
        <iframe
        src={usertype?"https://tsofie.com/term-and-conditions.html":"https://tsofie.com/term-and-conditions.html"}
        title="Terms of Service"
        className="w-full h-96"
      ></iframe>
        </div>
        <div className="term-btn bg-amber-950 w-20 rounded-lg mx-auto mt-3 cursor-pointer text-white mb-6 text-center hover:bg-amber-900" onClick={()=>setTerms(!terms)}>
            <button className="font-bold text-base" >OK</button>
        </div>
    </div>:""}
    {policy?<div className=" Privacy-Policy w-[70%] bg-gray-100 z-50 rounded-md max-sm:w-[90%]">
        <div className="Privacy-Policy-title text-center font-bold p-2 text-2xl shadow-md">
        <span className="title text-amber-950">Privacy Policy</span>
        </div>
        <div className="Privacy-Policy-containt h-full p-1 overflow-y-scroll border-b-2">
        <iframe
        src={usertype?"https://tsofie.com/privacy-policy.html":"https://tsofie.com/privacy-policy.html"}
        title="Terms of Service"
        className="w-full h-96"
      ></iframe>
        </div>
        <div className="term-btn bg-amber-950 w-20 rounded-lg mx-auto mt-3 cursor-pointer text-white mb-6 text-center hover:bg-amber-900" onClick={()=>setPolicy(!policy)}>
            <button className="font-bold text-base" >OK</button>
        </div>
    </div>:""}
    </div>:""}
    </>
  )
}
